
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-12346e58\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./dpae.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./dpae.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-12346e58\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dpae.vue.html"),
  /* scopeId */
  "data-v-12346e58",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dpae/dpae.vue.html
// module id = LS0T
// module chunks = 2